// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"backtop"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.5 14.5L12 9L6.5 14.5M5 5H19M12 10.25V20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BacktopIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'backtop',
    ref,
    icon: element,
  },
));

BacktopIcon.displayName = 'BacktopIcon';

export default BacktopIcon;
